import validate from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import marketing_45params_45global from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/middleware/marketing-params.global.ts";
import region_45middleware_45global from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/middleware/region-middleware.global.ts";
import manifest_45route_45rule from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  marketing_45params_45global,
  region_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  home: () => import("/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/middleware/home.ts")
}